import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { CustomInputField } from "../CommonComponents/CustomCompontes";
import { companyWiseEmp } from "../../actions/Companywiseclient";

function GeofenceDistanceConfiguration({ companyId, siteId }) {
  const [geofenceDistance, setGeofenceDistance] = React.useState("");
  const [
    enableMeetingAutoSubmitAfterCertainDistance,
    setEnableMeetingAutoSubmitAfterCertainDistance,
  ] = useState(false);
  const fetchGeofenceDataForCompany = async () => {
    const response = await companyWiseEmp.getGeofenceDistanceByCompany({
      companyId,
      siteId: siteId?.id,
    });
    if (response !== null && response.responseCode === 200) {
      setGeofenceDistance(response?.data?.configurationValue);
      setEnableMeetingAutoSubmitAfterCertainDistance(
        response?.data?.isMeetingAutoSubmitAfterCertainDistance
      );
    } else {
      setGeofenceDistance("");
    }
  };

  const handleSubmit = async () => {
    const response = await companyWiseEmp.saveGeofenceDistanceByCompany({
      companyId: companyId,
      siteId: siteId?.id ? siteId?.id : null,
      hrmsConfigurationName: "LOCAL_GEO_FENCE_RADIUS_IN_METERS",
      configurationValue: geofenceDistance ? parseInt(geofenceDistance) : 0,
      isActive: true,
      isMeetingAutoSubmitAfterCertainDistance:
        enableMeetingAutoSubmitAfterCertainDistance ? true : false,
    });
    if (response?.responseCode === 200) {
      alert(response.responseDescription);
      fetchGeofenceDataForCompany();
    } else {
      alert(response?.responseDescription || response);
    }
  };

  React.useEffect(() => {
    fetchGeofenceDataForCompany();
  }, [companyId]);
  return (
    <div>
      {/* <Grid className="CompanyBox"> */}
      <Accordion className="main_accoardian" defaultExpanded={true}>
        <AccordionSummary
          className="accordianHeader"
          expandIcon={
            <AddCircleIcon fontSize="large" style={{ color: "white" }} />
          }
          aria-controls="panel1a-content"
          style={{
            background: "rgb(10 166 141)",
            borderRadius: "10px 10px 0px 0px",
            overflow: "hidden",
          }}
        >
          <Grid>
            <Grid>
              <h3
                style={{
                  color: "#fff",
                  marginLeft: "10px",
                  padding: "10px 2px",
                }}
              >
                {/* Geofence Distance Configuration:- */}
                Set Geofence for Meeting Submission Alerts
              </h3>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ mt: 1 }}>
            <Grid container direction="row" spacing={3} alignItems="center">
              <Grid item spacing={3}>
                <CustomInputField
                  sx={{ width: "100%", margin: "0px !important" }}
                  required
                  value={geofenceDistance}
                  label="Geofence Distance "
                  variant="outlined"
                  size="small"
                  onChange={(e) =>
                    setGeofenceDistance(e.target.value.replace(/\D/g, ""))
                  }
                />
              </Grid>
              <Grid item sx={{ paddingTop: "8px !important" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={enableMeetingAutoSubmitAfterCertainDistance}
                      onChange={(e) =>
                        setEnableMeetingAutoSubmitAfterCertainDistance(
                          e?.target?.checked || false
                        )
                      }
                    />
                  }
                  label="Enable Distance-Based Meeting Auto-Submission"
                />
              </Grid>
              <Grid
                item
                style={{
                  placeItems: "center",
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: "10px",
                }}
              >
                <div className="field_box">
                  <div
                    className="field_box_btn1"
                    onClick={handleSubmit}
                    style={{
                      cursor: "pointer",
                      width: "60px",
                    }}
                  >
                    Save
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
      {/* </Grid> */}
    </div>
  );
}

export default GeofenceDistanceConfiguration;
